export function CloudCheckIcon({ ...rest }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M17.6 19.5H6.6a4.6 4.6 0 0 1-.6-9.16 6.1 6.1 0 0 1 11.63-1.2 5.05 5.05 0 0 1-.03 10.36Z" />
      <path d="m9.4 13.9 1.9 1.9 3.8-3.9" />
    </svg>
  );
}
